document.addtener("DOMContentLoaded", function () {
    function hideEmotiveIframeIfBot3() {
        const botInput = document.querySelector("#bot_trap3");
        const iframe = document.querySelector('iframe[src*="emotivecdn.io/embedded/index.html"]');

        if (!iframe) return; // iframe not yet in DOM

        // Agar session me already flag set hai → directly hide
        if (sessionStorage.getItem("botTrap3Triggered") === "true") {
            iframe.style.display = "none";
            return;
        }

        if (!botInput) return; // bot input not found yet

        const hasValue = botInput.value && botInput.value.trim() !== "";

        if (hasValue) {
            // Save in session so it stays hidden for this tab/session
            sessionStorage.setItem("botTrap3Triggered", "true");
            iframe.style.display = "none";
            console.log("🚫 bot_trap3 filled → emotive iframe permanently hidden (session)");
        } else {
            iframe.style.display = ""; // only show if session not triggered
        }
    }

    // Observe DOM changes (AJAX safe)
    new MutationObserver(hideEmotiveIframeIfBot3)
        .observe(document.body, { childList: true, subtree: true });

    // Check when bot_trap3 changes
    document.addEventListener("input", (e) => {
        if (e.target && e.target.id === "bot_trap3") {
            hideEmotiveIframeIfBot3();
        }
    });

    // Safety fallbackEventLis
    setInterval(hideEmotiveIframeIfBot3, 500);
});
